// extracted by mini-css-extract-plugin
export default {"uri-tag":"WtTe9Z56nIbn0yGSG7Iq"};